import "./Footer.css";
import Logofooter from "../../../assets/logo.png";
import { InstagramIcon, LinkedInIcon, WhatsAppIcon } from "../../utils/constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getRoutePaths, switchLangPath, useLang } from "../../utils/i18n";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lang = useLang();
  const paths = getRoutePaths(lang);
  const targetEn = switchLangPath(location.pathname, "en");
  const targetPt = switchLangPath(location.pathname, "pt");
  const copy = {
    en: {
      phone: "Phone",
      email: "Email",
      privacy: "Privacy Policy",
      disclaimer: "Legal Disclaimer",
      contact: "Contact",
      beliefs: "Our Principles",
      country: "Brazil",
      address: "Address",
      explore: "Explore",
      language: "Language",
      seoTitle: "Core Services",
      seoNav: "Core service links",
      seoLinks: [
        { key: "sf", label: "Strategic Finance Consulting & FP&A", to: "services" },
        { key: "cfo", label: "CFO Advisory & Business Partnering", to: "services" },
        { key: "comm", label: "Executive Communication & Business English", to: "school" },
        { key: "book", label: "Book a Strategic Finance Consultation", to: "contact" },
      ],
      seoText:
        "Monetique is a strategic finance consulting firm in São Paulo, Brazil, helping companies worldwide improve profitability through FP&A, CFO advisory, financial planning and AI-driven finance transformation.",
    },
    pt: {
      phone: "Telefone",
      email: "E-mail",
      privacy: "Política de Privacidade",
      disclaimer: "Aviso Legal",
      contact: "Contato",
      beliefs: "Nossos Princípios",
      country: "Brasil",
      address: "Endereço",
      explore: "Explorar",
      language: "Idioma",
      seoTitle: "Servicos em Destaque",
      seoNav: "Links de servicos principais",
      seoLinks: [
        { key: "sf", label: "Consultoria Financeira Estrategica e FP&A", to: "services" },
        { key: "cfo", label: "CFO Advisory e Business Partnering", to: "services" },
        { key: "comm", label: "Comunicacao Executiva e Business English", to: "school" },
        { key: "book", label: "Agende uma Consultoria Financeira", to: "contact" },
      ],
      seoText:
        "A Monetique e uma consultoria estrategica em financas em Sao Paulo, Brasil, ajudando empresas no mundo todo a melhorar a rentabilidade por meio de FP&A, CFO advisory, planejamento financeiro e transformacao financeira orientada por IA.",
    },
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-brand">
        <Link
          to={paths.home}
          className="footer-brand-link"
          aria-label={lang === "en" ? "Go to homepage" : "Ir para a página inicial"}
        >
          <img
            src={Logofooter}
            alt="Monetique"
            className="logofooter"
          />
        </Link>
      </div>
      <div className="footer-divider" />

      <div className="footer-grid">
        <section className="footer-block">
          <p className="footer-kicker">{copy[lang].address}</p>
          <p className="footer-address">
            Monetique Estratégia e Gestão Financeira Ltda.
            <br />
            Avenida Brigadeiro Faria Lima, 1811
            <br />
            Sala 1119
            <br />
            São Paulo, SP, {copy[lang].country}
          </p>
          <div className="social-icons-footer">
            <div className="footer-social-icon">
              <LinkedInIcon />
            </div>
            <div className="footer-social-icon">
              <InstagramIcon />
            </div>
            <div className="footer-social-icon">
              <WhatsAppIcon />
            </div>
          </div>
        </section>

        <section className="footer-block">
          <p className="footer-kicker">{copy[lang].phone}</p>
          <a href="tel:+5511944794757" className="footer-link footer-contact-link">
            <span className="footer-link-text">+55 11 94479-4757</span>
          </a>
          <p className="footer-kicker footer-kicker-spaced">{copy[lang].email}</p>
          <a href="mailto:info@monetiquepro.com" className="footer-link footer-contact-link">
            <span className="footer-link-text">info@monetiquepro.com</span>
          </a>
        </section>

        <nav className="footer-block footer-nav" aria-label={lang === "en" ? "Footer navigation" : "Navegação do rodapé"}>
          <p className="footer-kicker">{copy[lang].explore}</p>
          <Link className="footer-link" to={paths.privacy}>{copy[lang].privacy}</Link>
          <Link className="footer-link" to={paths.disclaimer}>{copy[lang].disclaimer}</Link>
          <Link className="footer-link" to={paths.contact}>{copy[lang].contact}</Link>
          <Link className="footer-link" to={paths.beliefs}>{copy[lang].beliefs}</Link>
        </nav>
      </div>

      <section className="footer-seo" aria-label={copy[lang].seoTitle}>
        <p className="footer-kicker">{copy[lang].seoTitle}</p>
        <nav className="footer-seo-links" aria-label={copy[lang].seoNav}>
          {copy[lang].seoLinks.map((item) => (
            <Link key={item.key} className="footer-seo-link" to={paths[item.to]}>
              <span className="footer-seo-link-label">{item.label}</span>
            </Link>
          ))}
        </nav>
        <p className="footer-seo-text">{copy[lang].seoText}</p>
      </section>

      <div className="footer-meta">
        <span className="footer-copyright">© {new Date().getFullYear()} Monetique</span>
        <div className="footer-lang-toggle" role="group" aria-label={copy[lang].language}>
          <button
            className={`footer-lang-option ${lang === "en" ? "active" : ""}`}
            type="button"
            onClick={() => navigate(targetEn)}
          >
            EN
          </button>
          <span className="footer-lang-separator">|</span>
          <button
            className={`footer-lang-option ${lang === "pt" ? "active" : ""}`}
            type="button"
            onClick={() => navigate(targetPt)}
          >
            PT
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
